<template>
	<div id="headers">
		{{navIndex.name}}
	</div>
</template>

<script>
import {mapState} from 'vuex';
export default {
  name: 'headers',
  computed:{
		...mapState(['navIndex']),
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#headers{
	display: inline-block;
	width: 100%;
	height: 1rem;
	background: #0068b6;
	position: fixed;
	top: 0px;
	left: 0px;
	z-index: 100;
	box-shadow: 0 0 2px #ccc;
	font-size: 0.36rem;
	color: #f5bf00;
	text-align: center;
	font-weight: 900;
	line-height: 1rem;
	background: url('../assets/img/mobBackground.jpg') repeat center;
	background-size: 100% auto;
	border-bottom: #00153b solid 0.08rem;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue